<template>
    <div id="tabs_content">
        <form autocomplete="off">
            <div class="inner_white">
                <div class="field_left">
                    <p>
                      <JSONTextareaInput
                          v-model="formFields.payload"
                          id="device_type_evaluation_tester_payload"
                          rows="20"
                      >
                        <translate class="translate">Data</translate>
                      </JSONTextareaInput>
                    </p>
                </div>
                <section class="buttons">
                    <p>
                        <input type="submit" :value="'Testovat' | translate" class="btn" @click.prevent.stop="test()">
                    </p>
                </section>
            </div>
        </form>

        <div v-if="result !== null" class="inner_white">
            <div class="scroll-wrapper">
                <div class="table_overflow">
                    <table class="vypis">
                        <thead>
                            <tr>
                                <th v-translate>Název</th>
                                <th v-translate>Typ zařízení</th>
                                <th v-translate>Počet shod</th>
                                <th v-translate>%</th>
                                <th v-translate>Shody</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in result" :key="item.id" :class="{'success': index === 0 && item.count > 0}">
                              <td><a class="link" @click.stop="showDeviceTypeEvaluationDetail(item.id)">{{ item.name }}</a></td>
                              <td><entity-link type="deviceType" :id="item.id_device_type">{{ item.name_device_type }}</entity-link></td>
                              <td>{{ item.hits_count }} / {{ item.total_count }}</td>
                              <td>{{ item.percentage }}</td>
                              <td>
                                <ul>
                                  <li v-for="(expr, index2) in item.hits" :key="item.id+'-'+index2">{{ expr }}</li>
                                </ul>
                              </td>
                            </tr>
                            <tr v-if="result.length === 0">
                                <td colspan="3">{{ $gettext('Žádné výsledky.') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import message from "@/components/mixins/message"
import JSONTextareaInput from "../../common/JSONTextareaInput.vue";
import EntityLink from "../../common/EntityLink.vue";
import formFields from "../../mixins/form-fields";

export default {
  name: "DeviceTypeEvaluationTester",
  components: { EntityLink, JSONTextareaInput },
  mixins: [formFields, message],
  data() {
    return {
      moduleName: 'deviceTypeEvaluations',
      result: null,
      formFields: {
        payload: "",
      }
    }
  },
  created(DeviceTypeEvaluationService) {
    this.entityService = DeviceTypeEvaluationService
    this.loadForm()
  },
  methods: {
    test() {
      this.setLoadingMessage()
      this.entityService.testDeviceTypeEvaluation({ payload: this.formFields.payload })
          .then(data => {
            this.result = data.result
            this.emptyMessage()
            this.saveForm()
          })
          .catch(error => {
            this.setErrorMessage(error.error_message)
          })
    },
    showDeviceTypeEvaluationDetail(id) {
      this.$router.push({ name: 'deviceTypeEvaluationDetail', params: { id } })
    },
    loadForm() {
      this.loadDefaultByKey('payload')
    },
    saveForm() {
      this.setUserSetting('payload', this.formFields.payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceTypeEvaluations/DeviceTypeEvaluationTester.vue